<!-- Agent Management Modal -->
<div class="modal-backdrop fade show" *ngIf="showModal"
     style="z-index: 1055 !important;"
     (click)="close()"></div>

<div class="modal fade show d-block" *ngIf="showModal"
     style="z-index: 1056 !important;"
     tabindex="-1" role="dialog">
  <div class="modal-dialog modal-lg modal-dialog-centered">
    <div class="modal-content">
      <!-- Modal Header -->
      <div class="modal-header">
        <h5 class="modal-title">Agent Management</h5>
        <button type="button" class="btn-close" (click)="close()"></button>
      </div>

      <!-- Modal Body -->
      <div class="modal-body">
        <!-- Search Bar and Add Button -->
        <div class="d-flex justify-content-between align-items-center mb-3">
          <div class="input-group" style="max-width: 300px;">
            <span class="input-group-text">
              <i class="bi bi-search"></i>
            </span>
            <input
              type="text"
              class="form-control"
              placeholder="Search agents..."
              [(ngModel)]="searchTerm"
              (input)="filterAgents()"
            />
          </div>
          <button class="btn btn-primary" (click)="openAddAgentModal()">
            <i class="bi bi-plus-circle me-1"></i>Add Agent
          </button>
        </div>

        <!-- Agents Table -->
        <div class="table-responsive">
          <table class="table table-hover align-middle">
            <thead>
              <tr>
                <th>Name</th>
                <th>Contact Info</th>
                <th>Status</th>
                <th>Actions</th>
              </tr>
            </thead>
            <tbody>
              <tr *ngFor="let agent of filteredAgents">
                <td><strong>{{ agent.name }}</strong></td>
                <td>{{ truncateText(agent.contactInformation) }}</td>
                <td>
                  <span class="badge bg-success" *ngIf="agent.isActive">Active</span>
                  <span class="badge bg-secondary" *ngIf="!agent.isActive">Inactive</span>
                </td>
                <td>
                  <button class="btn btn-sm btn-link p-1" (click)="openEditAgentModal(agent)" title="Edit">
                    <i class="bi bi-pencil"></i>
                  </button>
                  <button class="btn btn-sm btn-link text-danger p-1" (click)="deleteAgent(agent.id)" title="Delete">
                    <i class="bi bi-trash"></i>
                  </button>
                </td>
              </tr>
              <tr *ngIf="filteredAgents.length === 0">
                <td colspan="4" class="text-center text-muted py-4">
                  <i class="bi bi-inbox me-2"></i>No agents found
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>

      <!-- Modal Footer -->
      <div class="modal-footer">
        <button type="button" class="btn btn-secondary" (click)="close()">Close</button>
      </div>
    </div>
  </div>
</div>

<!-- Add Agent Modal (Nested) -->
<div class="modal-backdrop fade show" *ngIf="showAddModal"
     style="z-index: 1060 !important; background-color: rgba(0, 0, 0, 0.9) !important;"
     (click)="closeAddAgentModal()"></div>

<div class="modal fade show d-block" *ngIf="showAddModal"
     style="z-index: 1061 !important;"
     tabindex="-1" role="dialog">
  <div class="modal-dialog modal-dialog-centered">
    <div class="modal-content">
      <!-- Add Modal Header -->
      <div class="modal-header">
        <h5 class="modal-title">Add New Agent</h5>
        <button type="button" class="btn-close" (click)="closeAddAgentModal()"></button>
      </div>

      <!-- Add Modal Body -->
      <div class="modal-body">
        <form>
          <!-- Agent Name -->
          <div class="mb-3">
            <label for="addAgentName" class="form-label">Agent Name <span class="text-danger">*</span></label>
            <input
              type="text"
              class="form-control"
              id="addAgentName"
              [(ngModel)]="formData.name"
              name="name"
              placeholder="Enter agent name"
              required
            />
          </div>

          <!-- Contact Information -->
          <div class="mb-3">
            <label for="addContactInfo" class="form-label">Contact Information</label>
            <textarea
              class="form-control"
              id="addContactInfo"
              [(ngModel)]="formData.contactInformation"
              name="contactInformation"
              rows="4"
              placeholder="Email, phone, address, etc."></textarea>
          </div>

          <!-- Active Toggle -->
          <div class="mb-3">
            <label class="form-label d-block">Status</label>
            <div class="form-check form-switch">
              <input
                class="form-check-input"
                type="checkbox"
                id="addAgentActive"
                [(ngModel)]="formData.isActive"
                name="isActive"
              />
              <label class="form-check-label" for="addAgentActive">
                Active
              </label>
            </div>
          </div>
        </form>
      </div>

      <!-- Add Modal Footer -->
      <div class="modal-footer">
        <button type="button" class="btn btn-secondary" (click)="closeAddAgentModal()">Cancel</button>
        <button type="button" class="btn btn-primary" (click)="createAgent()">Create</button>
      </div>
    </div>
  </div>
</div>

<!-- Edit Agent Modal (Nested) -->
<div class="modal-backdrop fade show" *ngIf="showEditModal"
     style="z-index: 1060 !important; background-color: rgba(0, 0, 0, 0.9) !important;"
     (click)="closeEditAgentModal()"></div>

<div class="modal fade show d-block" *ngIf="showEditModal"
     style="z-index: 1061 !important;"
     tabindex="-1" role="dialog">
  <div class="modal-dialog modal-dialog-centered">
    <div class="modal-content">
      <!-- Edit Modal Header -->
      <div class="modal-header">
        <h5 class="modal-title">Edit Agent</h5>
        <button type="button" class="btn-close" (click)="closeEditAgentModal()"></button>
      </div>

      <!-- Edit Modal Body -->
      <div class="modal-body">
        <form>
          <!-- Agent Name -->
          <div class="mb-3">
            <label for="editAgentName" class="form-label">Agent Name <span class="text-danger">*</span></label>
            <input
              type="text"
              class="form-control"
              id="editAgentName"
              [(ngModel)]="editFormData.name"
              name="editName"
              required
            />
          </div>

          <!-- Contact Information -->
          <div class="mb-3">
            <label for="editContactInfo" class="form-label">Contact Information</label>
            <textarea
              class="form-control"
              id="editContactInfo"
              [(ngModel)]="editFormData.contactInformation"
              name="editContactInformation"
              rows="4"
              placeholder="Email, phone, address, etc."></textarea>
          </div>

          <!-- Active Toggle -->
          <div class="mb-3">
            <label class="form-label d-block">Status</label>
            <div class="form-check form-switch">
              <input
                class="form-check-input"
                type="checkbox"
                id="editAgentActive"
                [(ngModel)]="editFormData.isActive"
                name="editIsActive"
              />
              <label class="form-check-label" for="editAgentActive">
                Active
              </label>
            </div>
          </div>
        </form>
      </div>

      <!-- Edit Modal Footer -->
      <div class="modal-footer">
        <button type="button" class="btn btn-secondary" (click)="closeEditAgentModal()">Cancel</button>
        <button type="button" class="btn btn-primary" (click)="updateAgent()">Update</button>
      </div>
    </div>
  </div>
</div>
